export default __webpack_public_path__ + "static/media/heading.9debe9b2.png";